import { useEffect } from "react";
import { Grid, Box } from "@mui/material";
import BugImage from "@/src-refactor/assets/images/bug-fixing.svg?react";
import Screenshot from "@/src-refactor/assets/images/screenshot.svg?react";
import User from "@/src-refactor/assets/images/profile.svg?react";
import Actions from "@/src-refactor/assets/images/actions.svg?react";
import MxDetailLayoutMain from "@rf-l1/page/details/MxDetailLayoutMain";
import MxTypography from "@rf-l1/MxTypography";
import { ActionsCard } from "./ActionsCard";
import { ErrorFallbackActionButtons } from "./ActionButtons";

interface ErrorFallbackProps {
  error?: Error;
  resetErrorBoundary: () => void;
}

export function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  useEffect(() => {
    console.log("ErrorBoundaryComponent", error);
  }, [error?.message]);

  return (
    <MxDetailLayoutMain
      bgcolor="background.default"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Grid container gap={2}>
        <Grid item xs={12}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ "& svg": { width: "13rem", height: "13rem" } }}
          >
            <BugImage />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <MxTypography variant="subtitle1" color="primary.main" align="center">
            Upss... Ha ocurrido un inconveniente.
          </MxTypography>
        </Grid>
        <Grid item xs={12}>
          <MxTypography variant="subtitle2" color="grey.600" align="center">
            Comunícate con la Mesa de Ayuda y, para optimizar el servicio, ten en
            cuenta lo siguiente:
          </MxTypography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={10}
          md={8}
          lg={6}
          container
          spacing={2}
          mt={1}
          mx="auto"
        >
          <ActionsCard
            icon={Screenshot}
            text="Tomar una captura de tu pantalla completa"
          />
          <ActionsCard
            icon={User}
            text="Provee tu nombre completo y tipo de usuario"
          />
          <ActionsCard icon={Actions} text="Notifica qué acción intentabas hacer" />
        </Grid>
        <ErrorFallbackActionButtons resetErrorBoundary={resetErrorBoundary} />
      </Grid>
    </MxDetailLayoutMain>
  );
}
